<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-0 pb-md-1 prevent-select">
            <b-card no-body class="py-50 px-2 mb-1">
                <b-row class="align-items-center">
                    <b-col md="8">
                        <b-row>
                            <b-col md="2" cols="6" class="display-none-sm-invoice py-1">
                                <div class="d-flex align-items-center">
                                    <b-form-checkbox v-model="automaticPrinting" class="custom-control-info"
                                        name="check-button" :disabled="!(certificateId || certificateId == 0)" switch />
                                    <div class="mb-0 ml-25">
                                        <feather-icon icon="PrinterIcon" size="26" />
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="10" cols="6" class="py-1">
                                <div>
                                    <b-form-input v-model="orderForm.description" autocomplete="off" id="description"
                                        dir="rtl" class="text-center" placeholder="توضیحات سفارش" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="4">
                        <b-row>
                            <b-col md="4" cols="4" class="py-1">
                                <div @click="showModalCustomersFind" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon :class="{ 'text-muted': loading.customersFind }" icon="UserIcon"
                                            size="26" />
                                    </div>
                                    <div style="font-size: 13px;" :class="{ 'text-muted': loading.customersFind }"
                                        class="font-weight-bolder text-center">مشتری
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="4" cols="4" class="py-1">
                                <div @click="ordersToday" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon icon="FileTextIcon" size="26"
                                            :class="{ 'text-muted': loading.ordersToday }" />
                                    </div>
                                    <div style="font-size: 13px;" class="font-weight-bolder text-center"
                                        :class="{ 'text-muted': loading.ordersToday }">
                                        پیش‌سفارش</div>
                                </div>
                            </b-col>
                            <b-col md="4" cols="4" class="py-1">
                                <div @click="deleteInvoice" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon icon="TrashIcon" size="26" />
                                    </div>
                                    <div style="font-size: 13px;" class="font-weight-bolder text-center">حذف اطلاعات
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <b-card v-if="customer.phoneNumber" no-body class="mb-1">
                <div class="d-flex flex-wrap flex-column flex-md-row justify-content-center pt-1">
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">نام مشتری: </h6>
                            <h5 class="mb-0 ml-25">
                                {{ customer.firstName || customer.lastName ? `${customer.firstName}
                                ${customer.lastName}` : '' }}
                            </h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">شماره همراه: </h6>
                            <h5 class="mb-0 ml-25">{{ customer.phoneNumber ? customer.phoneNumber : '' }}</h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">شماره اشتراک: </h6>
                            <h5 class="mb-0 ml-25">{{ customer.number ? customer.number : '' }}</h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">سطح: </h6>
                            <h5 class="mb-0 ml-25">{{ customer.loyaltyInfo ? `${customer.loyaltyInfo.loyaltyLevel.name}
                                /
                                ${customer.loyaltyInfo.loyaltyLevel.number}` : '' }}</h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">امتیاز: </h6>
                            <h5 class="mb-0 ml-25">
                                {{ customer.loyaltyInfo ? customer.loyaltyInfo.score.toLocaleString('fa-IR') : '' }}
                            </h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">اعتبار: </h6>
                            <h5 class="mb-0 ml-25">
                                {{ customer.loyaltyInfo ? customer.loyaltyInfo.walletBalance.toLocaleString('fa-IR') :
                                    '' }}
                                <span v-if="customer.loyaltyInfo" class="mb-0 text-muted">
                                    {{ customer.loyaltyInfo.walletBalance ? 'ریال' : null }}
                                </span>
                            </h5>
                        </div>
                    </div>
                </div>
            </b-card>
            <b-row class="match-height">
                <b-col xl="8" lg="8" md="12">
                    <b-row class="match-height h-100">
                        <b-col xl="3" lg="4" cols="4" class="pr-25 pr-md-1">
                            <div class="overflow-y-scroll-invoice mb-1">
                                <b-card no-body @dblclick.prevent class="mb-0">
                                    <div v-for="(item, index) in categories" :key="`category${index}`"
                                        :class="{ 'bg-info-invoice': category.id == item.id }"
                                        class="pointer border-bottom-invoice p-1" @click="selectCategory(item)">
                                        <h5 class="mb-0" :class="{ 'text-white': category.id == item.id }">
                                            {{ item.name_Fa }}
                                        </h5>
                                    </div>
                                </b-card>
                            </div>
                        </b-col>
                        <b-col xl="9" lg="8" cols="8" class="pl-25 pl-md-1">
                            <b-card no-body class="overflow-y-scroll-invoice mb-1">
                                <div class="h-100">
                                    <div v-if="category.products.length"
                                        class="d-flex flex-wrap justify-content-center py-50" @dblclick.prevent>
                                        <div v-for="(item, index) in category.products" :key="index"
                                            :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                            class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative invoice-registration-bg"
                                            @click="addedToOrderList(item)">
                                            <div v-if="item.number"
                                                class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    {{ item.number }}
                                                </div>
                                            </div>
                                            <div v-if="item.number" @click.stop="subtractProduct(item)"
                                                class="position-absolute text-white z-index-2 rounded-circle"
                                                style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <feather-icon icon="MinusCircleIcon" size="24"
                                                        class="text-danger" />
                                                </div>
                                            </div>
                                            <div v-if="item.discountPercent"
                                                class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            {{ item.discountPercent }}
                                                        </div>
                                                        <div>%</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="position-absolute z-index-1 rounded invoice-registration-cover-product"
                                                :class="{ 'invoice-registration-cover-product-warning': !item.isAvailable }"
                                                :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                            </div>
                                            <div v-if="item.image"
                                                class="position-absolute rounded invoice-registration-bg-main"
                                                :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                <img :src="BASE_URL_File + item.image"
                                                    class="object-fit-cover rounded w-100 h-100">
                                            </div>
                                            <div
                                                class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                <div class="mb-0 text-white text-ellipsis-single-invoice"
                                                    style="font-size: 16px;">
                                                    {{ item.name_Fa }}
                                                </div>
                                                <div class="d-flex align-items-center justify-content-center mb-0"
                                                    style="color: #dddddd;">
                                                    <div style="font-size: 16px;">
                                                        {{ item.basePrice.toLocaleString('fa-IR') }}
                                                    </div>
                                                    <div class="pb-25 pl-25">
                                                        ریال
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div @dblclick.prevent>
                                        <div v-for="(subCategories, index) in category.subCategories" class="mt-1"
                                            :key="`subCategories${index}`">
                                            <div class="mx-75 mb-25 mb-md-0 px-1 py-50 rounded border border-secondary text-center"
                                                style="font-size: 16px;">
                                                {{ subCategories.name_Fa }}
                                            </div>
                                            <div class="d-flex flex-wrap justify-content-center">
                                                <div v-for="(item, index) in subCategories.products"
                                                    :key="`products${index}`"
                                                    :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                                    class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative invoice-registration-bg"
                                                    @click="addedToOrderList(item)">
                                                    <div v-if="item.number"
                                                        class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                        style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            {{ item.number }}
                                                        </div>
                                                    </div>
                                                    <div v-if="item.number" @click.stop="subtractProduct(item)"
                                                        class="position-absolute text-white z-index-2 rounded-circle"
                                                        style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <feather-icon icon="MinusCircleIcon" size="24"
                                                                class="text-danger" />
                                                        </div>
                                                    </div>
                                                    <div v-if="item.discountPercent"
                                                        class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                        style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <div class="d-flex align-items-center">
                                                                <div>
                                                                    {{ item.discountPercent }}
                                                                </div>
                                                                <div>%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="position-absolute z-index-1 rounded invoice-registration-cover-product"
                                                        :class="{ 'invoice-registration-cover-product-warning': !item.isAvailable }"
                                                        :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                                    </div>
                                                    <div v-if="item.image"
                                                        class="position-absolute rounded invoice-registration-bg-main"
                                                        :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                        <img :src="BASE_URL_File + item.image"
                                                            class="object-fit-cover rounded w-100 h-100">
                                                    </div>
                                                    <div
                                                        class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                        <div class="mb-0 text-white text-ellipsis-single-invoice"
                                                            style="font-size: 16px;">
                                                            {{ item.name_Fa }}
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-center mb-0"
                                                            style="color: #dddddd;">
                                                            <div style="font-size: 16px;">
                                                                {{ item.basePrice.toLocaleString('fa-IR') }}
                                                            </div>
                                                            <div class="pb-25 pl-25">
                                                                ریال
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col xl="4" lg="4" md="12">
                    <b-card class="mb-1">
                        <b-row>
                            <b-col xl="6" lg="12" md="6">
                                <b-form-group label="نوع پرداخت">
                                    <v-select v-model="paymentMethod" :searchable="false" dir="rtl"
                                        :options="paymentMethodItems" :reduce="(value) => value.id" label="name"
                                        id="paymentMethodId" class="bg-white" style="border-radius: 6px;"
                                        :clearable="false">
                                    </v-select>
                                </b-form-group>
                            </b-col>
                            <b-col xl="6" lg="12" md="6">
                                <b-form-group label="نوع سفارش">
                                    <v-select v-model="orderForm.type" :searchable="false" dir="rtl"
                                        :options="orderTypeItems" :reduce="(value) => value.id" label="name"
                                        id="orderTypeItemsId" class="bg-white" style="border-radius: 6px;"
                                        :clearable="false">
                                    </v-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <hr class="border-secondary mt-50 mb-25">
                        <div class="px-1 orders-container">
                            <div v-if="ordersList.length">
                                <div v-for="(item, index) in ordersList" :key="`order${index}`"
                                    class="py-75 d-flex align-items-center"
                                    :class="{ 'border-bottom': index != ordersList.length - 1 || index == 0 }">
                                    <div class="w-100">
                                        <div class="d-flex justify-content-between mb-75">
                                            <h5 class="mb-0">
                                                {{ item.name_Fa }}
                                            </h5>
                                            <div v-if="item.discountPercent" class="d-flex align-items-center">
                                                <h5 class="font-weight-bolder text-danger mb-0">
                                                    {{ item.discountPercent }}
                                                </h5>
                                                <div class="text-muted ml-25">%</div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-between align-items-center"
                                                @dblclick.prevent style="width: 80px;">
                                                <feather-icon @click="addProduct(item)" icon="PlusCircleIcon"
                                                    class="pointer text-success" size="18" />
                                                <span class="font-weight-bolder">{{ item.number }}</span>
                                                <feather-icon @click="subtractProduct(item)" icon="MinusCircleIcon"
                                                    class="pointer text-danger" size="18" />
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <h5 v-if="item.discountPercent"
                                                    class="mr-75 mb-0 text-muted font-weight-bolder">
                                                    {{ item.basePrice.toLocaleString('fa-IR') }}
                                                </h5>
                                                <div class="d-flex align-items-center">
                                                    <h5 class="mb-0 font-weight-bolder">
                                                        {{ item.finalPrice.toLocaleString('fa-IR') }}
                                                    </h5>
                                                    <h6 class="pb-25 ml-25 mb-0 text-muted">ریال</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 v-else class="d-flex align-items-center justify-content-center h-100 mb-0 py-5">
                                محصولی به سفارش اضافه نشده است!
                            </h5>
                        </div>
                        <hr class="border-secondary mt-25">
                        <div @click="showDiv = !showDiv" class="d-flex align-items-center">
                            <h5 class="mb-0 mr-50">تخفیف و اعتبار</h5>
                            <feather-icon v-if="!showDiv" icon="ChevronDownIcon" class="pointer" size="18" />
                            <feather-icon v-else icon="ChevronUpIcon" class="pointer" size="18" />
                        </div>
                        <div v-if="showDiv" class="toggle-content-invoice mt-1">
                            <b-row>
                                <b-col xl="6" lg="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="تخفیف دستی ریالی">
                                            <b-input-group>
                                                <cleave id="number" dir="ltr" v-model="discountAmount"
                                                    inputmode="numeric" autocomplete="off" placeholder="0"
                                                    class="form-control text-center" :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="applyDiscount('rial')"
                                                        variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                                <b-col xl="6" lg="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="تخفیف دستی درصدی">
                                            <b-input-group>
                                                <cleave id="number" dir="ltr" v-model="percentageDiscountAmount"
                                                    inputmode="numeric" autocomplete="off" placeholder="0"
                                                    class="form-control text-center" :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="applyDiscount('percentage')"
                                                        variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mt-50">
                                <b-col md="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="استفاده از اعتبار (ریال)">
                                            <b-input-group>
                                                <cleave id="number" dir="ltr" v-model="orderFormWalletAmount"
                                                    inputmode="numeric" :disabled="!customer.loyaltyInfo"
                                                    autocomplete="off" placeholder="0" class="form-control text-center"
                                                    :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="orderUseWalletOk"
                                                        :disabled="!customer.loyaltyInfo" variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group label="کمپین">
                                        <v-select v-model="campaignDetails" :searchable="false" dir="rtl"
                                            :disabled="!campaignsList.length" :options="campaignsList" label="title"
                                            id="campaignDetailsId" class="bg-white" style="border-radius: 6px;">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                        <hr class="border-secondary mt-1">
                        <b-row class="mt-1">
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تعداد </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">{{ orderDetails.numberProducts }}
                                        </h5>
                                        <span v-if="orderDetails.numberProducts" class="text-muted">عدد</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> جمع سفارش </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round(orderDetails.orderAmount).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="orderDetails.orderAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> مالیات </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetails.orderAmount *
                                                0.10) : 0)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="calculatingTaxAuto && orderDetails.orderAmount * 0.10 != 0"
                                            class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> جمع کل </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetails.totalAmount +
                                                (orderDetails.orderAmount * 0.10)) :
                                                orderDetails.totalAmount)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="calculatingTaxAuto ? (orderDetails.totalAmount +
                                            (orderDetails.orderAmount * 0.10)) :
                                            orderDetails.totalAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col v-if="!!campaignDetails" md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تخفیف کمپین </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetails.totalAmount +
                                                (orderDetails.orderAmount * 0.10)) :
                                                orderDetails.totalAmount) * (campaignDetails.discountPercent /
                                                    100)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="((calculatingTaxAuto ? (orderDetails.totalAmount +
                                            (orderDetails.orderAmount * 0.10)) :
                                            orderDetails.totalAmount) * (campaignDetails.discountPercent /
                                                100))" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تخفیف دستی </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round(orderForm.discountAmount).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="orderForm.discountAmount != 0" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> اعتبار </span>
                                    <span class="line-between-two-elements-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ orderForm.walletAmount ? orderForm.walletAmount.toLocaleString('fa-IR') :
                                                '0' }}
                                        </h5>
                                        <span v-if="orderForm.walletAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="d-flex justify-content-center align-items-center mt-50">
                            <div class="d-flex align-items-center mb-2 mx-1">
                                <span> مبلغ قابل پرداخت : </span>
                                <h3 class="text-success mb-0 mx-25">
                                    {{
                                        Math.max(
                                            Math.round(((calculatingTaxAuto ? orderDetails.amountPayable +
                                                (orderDetails.orderAmount * 0.10) :
                                                orderDetails.amountPayable) - (campaignDetails ? ((calculatingTaxAuto ?
                                                    (orderDetails.totalAmount +
                                                        (orderDetails.orderAmount * 0.10)) : orderDetails.totalAmount) *
                                                    (campaignDetails.discountPercent / 100)) :
                                                    0) - (orderForm.useWallet ? orderForm.walletAmount :
                                                        0))), 0).toLocaleString('fa-IR')
                                    }}
                                </h3>
                                <span v-if="calculatingTaxAuto ? (orderDetails.amountPayable +
                                    (orderDetails.orderAmount * 0.10)) :
                                    orderDetails.amountPayable" class="text-muted font-weight-bold">ریال</span>
                            </div>
                        </div>
                        <b-button type="submit" variant="primary" @click="ordersCreateHandle"
                            :disabled="loading.ordersCreate"
                            class="w-100 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.ordersCreate" class="mr-50" variant="white" small></b-spinner>
                            <span>ثبت سفارش</span>
                        </b-button>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal pre invoices list ------------------------------->
        <b-modal id="pre-invoices-list" title="افزودن پیش‌سفارش" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <div class="p-1">
                <b-form-input dir="rtl" v-model="searchPreInvoices" @input="searchPreInvoicesList" autocomplete="off"
                    class="text-center mb-2" placeholder="جستجو" />
                <div v-if="filterPreInvoicesList.length">
                    <div v-for="(item, index) in filterPreInvoicesList" :key="`preInvoices${index}`"
                        @click="ordersPreorderFind(item)"
                        class="pre-invoices-item border rounded pointer mb-1 pt-1 pb-50 px-2"
                        style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);">
                        <b-row>
                            <b-col lg="5" md="12">
                                <div class="d-flex align-items-center">
                                    <h6 class="mr-25">نام مشتری :</h6>
                                    <h6 class="font-weight-bolder">
                                        {{
                                            item.customer && item.customer.lastName ? item.customer.lastName : 'ثبت نشده'
                                        }}
                                    </h6>
                                </div>
                            </b-col>
                            <b-col lg="4" md="12">
                                <div class="d-flex align-items-center">
                                    <h6 class="mr-25">شماره سفارش: </h6>
                                    <h6 class="font-weight-bolder">
                                        {{ item.dailyNumber }}
                                    </h6>
                                </div>
                            </b-col>

                            <b-col lg="3" md="12">
                                <div class="d-flex align-items-center">
                                    <h6 class="mr-25">جایگاه: </h6>
                                    <h6 class="font-weight-bolder">
                                        {{ item.tableName ? item.tableName : 'ثبت نشده' }}
                                    </h6>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <h5 v-else class="d-flex align-items-center justify-content-center pt-2 pb-1">
                    موردی وجود ندارد!
                </h5>
            </div>
        </b-modal>

        <!------------------------------- modal customers find ------------------------------->
        <b-modal id="customers-find" title="افزودن مشتری" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <validation-observer ref="customersFindValidation">
                    <b-form @submit.prevent>
                        <b-form-group label="نام یا شماره اشتراک" label-for="searchCustomer" class="text-center">
                            <v-select dir="rtl" v-model="searchCustomer" :options="customerList" :filterable="false"
                                id="searchCustomer" @search="handleSearchCustomer" :loading="loadingCustomer"
                                :get-option-label="(option) => option.number + ' - ' + option.firstName + ' ' + option.lastName">
                                <template #option="{ number, firstName, lastName, phoneNumber }">
                                    <div class="d-flex align-items-center">
                                        <div>{{ number }}</div>
                                        <span class="mx-50">-</span>
                                        <div class="mr-50">{{ firstName }}</div>
                                        <div>{{ lastName }}</div>
                                        <span class="mx-50">/</span>
                                        <div>{{ phoneNumber }}</div>
                                    </div>
                                </template>
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                                <template #spinner="{ loading }">
                                    <div v-if="loadingCustomer" style="border-right-color: #7367f0" class="vs__spinner">
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>
                        <b-form-group label="شماره همراه" label-for="phone" class="text-center mt-3">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <cleave :disabled="!!searchCustomer" id="phone" dir="ltr" v-model="customerPhoneNumber"
                                    inputmode="numeric" autocomplete="off"
                                    class="form-control text-center font-weight-bolder"
                                    :class="{ 'border-danger': errors.length > 0 }" :options="options.phone" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-button type="submit" variant="info" @click="customersFind" :disabled="loading.customersFind"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.customersFind" class="mr-50" variant="white" small></b-spinner>
                            <span>افزودن</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal create customer ------------------------------->
        <b-modal id="create-customer" title="ایجاد مشتری" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <validation-observer ref="createCustomerValidation">
                    <b-form @submit.prevent>

                        <!-- firstName -->
                        <b-form-group label="نام" label-for="firstNameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="firstNameId"
                                    v-model="customerForm.firstName" name="firstName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- lastName -->
                        <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="lastNameId"
                                    v-model="customerForm.lastName" name="lastName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- phone number -->
                        <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <b-form-input autocomplete="off" dir="ltr" id="phoneNumberId" inputmode="numeric"
                                    v-model="customerForm.phoneNumber" name="phoneNumber"
                                    :state="errors.length > 0 ? false : null"
                                    class="text-center font-weight-bolder user-select-none" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- birthDate -->
                        <div>
                            <b-form-group label="تاریخ تولد" label-for="birthDateId" class="text-center">
                                <b-form-input id="birthDateId" class="text-center main-input font-weight-bolder pointer"
                                    :value="customerForm.birthDate ? new Date(customerForm.birthDate).toLocaleDateString('fa-IR') : null"
                                    name="birthDateId" />
                            </b-form-group>
                            <date-picker v-model="customerForm.birthDate" :max="currentDate" format="YYYY-MM-DD"
                                display-format="jYYYY-jMM-jDD" custom-input="#birthDateId" />
                        </div>

                        <!-- gender -->
                        <div>
                            <div class="label mb-25 text-center">جنسیت</div>
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 100%;height: 2.714rem;">
                                <div class="d-flex align-items-center">
                                    <b-form-radio v-model="customerForm.gender" name="some-radios" :value="0"
                                        class="custom-control-primary mr-2">
                                        آقا
                                    </b-form-radio>
                                    <b-form-radio v-model="customerForm.gender" name="some-radios" :value="1"
                                        class="custom-control-primary ml-2">
                                        خانم
                                    </b-form-radio>
                                </div>
                            </div>
                        </div>

                        <b-button type="submit" variant="primary" @click="createCustomer"
                            :disabled="loading.createCustomer"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.createCustomer" class="mr-50" variant="white" small></b-spinner>
                            <span>ایجاد</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>


        <!------------------------------- modal enter amount ------------------------------->
        <b-modal id="enter-amount" title="پرداخت ترکیبی" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <b-form @submit.prevent>
                    <div class="d-flex align-items-center justify-content-center">
                        <div>مبلغ قابل پرداخت :</div>
                        <div class="d-flex align-items-center ml-50">
                            <h3 class="text-success mb-0">
                                {{
                                    Math.max(
                                        Math.round(((calculatingTaxAuto ? orderDetails.amountPayable +
                                            (orderDetails.orderAmount * 0.10) :
                                            orderDetails.amountPayable) - (campaignDetails ? ((calculatingTaxAuto ?
                                                (orderDetails.totalAmount +
                                                    (orderDetails.orderAmount * 0.10)) : orderDetails.totalAmount) *
                                                (campaignDetails.discountPercent / 100)) :
                                                0) - (orderForm.useWallet ? orderForm.walletAmount :
                                                    0))), 0).toLocaleString('fa-IR')
                                }}
                            </h3>
                            <span v-if="calculatingTaxAuto ? (orderDetails.amountPayable +
                                (orderDetails.orderAmount * 0.10)) :
                                orderDetails.amountPayable" class="text-muted font-weight-bold ml-25">ریال</span>
                        </div>
                    </div>
                    <div v-for="(item, index) in combinedPayment" :key="`payment_${index}`" class="mt-2">
                        <b-form-group :label="item.name" label-for="phone" class="text-center">
                            <cleave id="number" dir="ltr" v-model="item.amount" autocomplete="off" placeholder="0"
                                inputmode="numeric" class="form-control font-weight-bolder text-center"
                                :options="options.number" />
                        </b-form-group>
                    </div>
                    <b-button type="submit" variant="primary" @click="combinedPaymentHandle"
                        :disabled="loading.ordersCreate"
                        class="w-100 mt-2 d-flex align-items-center justify-content-center">
                        <b-spinner v-if="loading.ordersCreate" class="mr-50" variant="white" small></b-spinner>
                        <span>ثبت سفارش</span>
                    </b-button>
                </b-form>
            </div>
        </b-modal>

        <div v-if="certificateId || certificateId == 0">
            <Printer ref="Printer" :customerInvoice="orderPrint" :provider="provider" @deleteInvoice="deleteInvoice" />
        </div>
    </div>
</template>

<script>
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, phoneNumber } from '@validations';
import Printer from '@/@core/components/printer/index.vue';
import {
    BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormInput, BInputGroupAppend, BFormGroup, BFormCheckbox, BDropdown, BFormRadio, BSpinner, BDropdownItem, BAvatar, BFormTextarea, BDropdownItemButton, BInputGroupPrepend, BInputGroup
} from 'bootstrap-vue';
import { storeService } from '@core/services';
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BInputGroupPrepend,
        BInputGroup,
        Printer,
        BFormCheckbox,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BFormGroup,
        BFormRadio,
        BRow,
        BFormTextarea,
        BCol,
        BSpinner,
        BForm,
        BFormInput,
        BDropdownItem,
        BDropdown,
        BDropdownItemButton,
        BInputGroupAppend,
        BAvatar,
        vSelect
    },
    directives: {
        Ripple,
    },
    mixins: [accessHandling],
    data() {
        return {
            orderTypeItems: [
                { name: 'داخل سالن', id: 0 },
                { name: 'بیرون بر', id: 1 },
            ],
            paymentMethodItems: [
                { name: 'کارت', id: 1 },
                { name: 'نقدی', id: 0 },
                { name: 'واریز به حساب', id: 3 },
                { name: 'ترکیبی', id: 4 },
            ],
            combinedPayment: [
                { name: 'نقدی', method: 0, amount: null },
                { name: 'کارت', method: 1, amount: null },
                { name: 'واریز به حساب', method: 3, amount: null },
            ],
            showDiv: false,
            certificateId: null,
            required,
            phoneNumber,
            automaticPrinting: true,
            currentDate: '',
            urlName: '',
            orderNumber: 1,
            provider: {},
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
                phone: {
                    phone: true,
                    phoneRegionCode: 'IR',
                    delimiter: '-',
                }
            },
            loadingPage: true,
            loading: {
                customersFind: false,
                createCustomer: false,
                ordersCreate: false,
                ordersToday: false
            },
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            isAdminIdentityVerified: false,
            storeId: null,
            categories: [],
            category: {
                products: []
            },
            ordersList: [],
            orderPrint: {
                items: []
            },
            printQueue: [],
            isPrinting: false,
            orderDetails: {
                numberProducts: 0,
                totalAmount: 0,
                orderAmount: 0,
                amountPayable: 0
            },
            customer: {
                phoneNumber: null,
                lastName: null,
                number: null,
                firstName: null,
                address: null,
                loyaltyInfo: null,
                group: null,
                favoriteProduct: null

            },
            customerForm: {
                gender: null,
                birthDate: null,
                lastName: null,
                firstName: null,
                phoneNumber: null
            },
            dataResponse: {},
            customerPhoneNumber: null,
            itemCustomerNumber: null,
            orderForm: {
                discountAmount: 0,
                payments: [],
                type: 0,
                orderId: null,
                items: [],
                tableId: null,
                description: null,
                customerNumber: null,
                useWallet: false,
                walletAmount: 0,
                campaignId: null
            },
            orderFormWalletAmount: 0,
            paymentMethod: 1,
            customerLastName: null,
            customerFirstName: null,
            ordersTodayParameters: {
                pageIndex: 1,
                pageSize: 90,
                isPreOrder: true,
                isReturned: false

            },
            preInvoicesList: [],
            filterPreInvoicesList: [],
            discountAmount: null,
            percentageDiscountAmount: null,
            calculatingTaxAuto: false,
            searchPreInvoices: null,
            debounceTimeout: null,
            parameters: {
                pageIndex: 1,
                pageSize: 4,
                searchTerm: null,
            },
            customerList: [],
            loadingCustomer: false,
            searchCustomer: null,
            campaignsList: [],
            campaignsListMain: [],
            campaignDetails: null,
            isCustomerCampaign: false
        }
    },
    watch: {
        automaticPrinting(value) {
            localStorage.setItem("automaticPrinting", value)
        },
        'orderDetails.numberProducts'() {
            let discountAmount = this.orderForm.discountAmount;
            let totalAmount = this.calculatingTaxAuto ? (this.orderDetails.totalAmount + (this.orderDetails.orderAmount * 0.10)) : this.orderDetails.totalAmount
            if (discountAmount > totalAmount) {
                this.orderDetails.amountPayable = this.orderDetails.amountPayable + this.orderForm.discountAmount
                this.orderForm.discountAmount = 0
            }
        },
        'searchCustomer'() {
            if (this.searchCustomer) {
                this.customerPhoneNumber = this.searchCustomer.phoneNumber
            }
        },
    },
    methods: {
        getCampaignsActives() {
            storeService.getCampaignsActives(this.storeId).then(({ data }) => {
                this.campaignsListMain = data.items
                this.campaignsListMain.forEach(item => {
                    if (item.type == 2) {
                        this.campaignsList.push(item)
                    }
                    if (item.type == 0 || item.type == 1) {
                        this.isCustomerCampaign = true
                    }
                });
                if (this.campaignsList.length) {
                    this.campaignDetails = this.campaignsList[0]
                }
                this.getInfo()
            })
        },
        showModalCustomersFind() {
            if (this.accessHandling('employee', 'customer_create')) {
                if (this.itemCustomerNumber) {
                    if (!this.loading.customersFind) {
                        this.loading.customersFind = true
                        this.getCustomers(this.itemCustomerNumber)
                    }
                }
                else {
                    this.$bvModal.show('customers-find')
                }
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        getCustomers(searchTerm) {
            this.parameters.searchTerm = searchTerm
            storeService.getCustomers(this.storeId, this.parameters).then(({ data }) => {
                this.customerList = data.items
                if (this.itemCustomerNumber) {
                    this.customerList = []
                    this.loading.customersFind = false
                    this.itemCustomerNumber = null
                    if (data.items.length) {
                        this.customerPhoneNumber = data.items[0].phoneNumber
                    }
                    this.$bvModal.show('customers-find')
                }
                this.loadingCustomer = false
            })
        },
        handleSearchCustomer(searchTerm) {
            this.loadingCustomer = true
            clearTimeout(this.debounceTimeout)
            if (!searchTerm) {
                this.customerList = []
                this.loadingCustomer = false
                return
            }
            this.debounceTimeout = setTimeout(() => {
                this.getCustomers(searchTerm)
            }, 1000)
        },
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        searchPreInvoicesList() {
            this.filterPreInvoicesList = this.preInvoicesList.filter(item =>
                ['dailyNumber', 'tableName', 'customer.lastName'].some(field => {
                    let value;
                    if (field.includes('.')) {
                        const fields = field.split('.');
                        value = fields.reduce((obj, f) => (obj && obj[f] ? obj[f] : null), item);
                    } else {
                        value = item[field];
                    }
                    return value &&
                        (typeof value === 'string' ?
                            value.toLowerCase().includes(this.searchPreInvoices) :
                            String(value).toLowerCase().includes(this.searchPreInvoices));
                })
            );
        },
        keyboardHandling(event) {
            if (event.keyCode === 121 || event.keyCode === 120 && !this.loading.ordersCreate) {
                this.ordersCreateHandle();
            }
        },
        deleteInvoice() {
            this.customerFirstName = null
            this.itemCustomerNumber = null
            this.customerLastName = null
            this.customerForm.gender = null
            this.customerForm.birthDate = null
            this.customerForm.lastName = null
            this.customerForm.firstName = null
            this.customerForm.phoneNumber = null
            this.customer.number = null
            this.customer.lastName = null
            this.customer.firstName = null
            this.customer.phoneNumber = null
            this.customer.address = null
            this.customer.loyaltyInfo = null
            this.orderPrint.address = null
            this.orderPrint.phoneNumber = null
            this.orderPrint.firstName = null
            this.orderPrint.lastName = null
            this.orderForm.discountAmount = 0
            this.paymentMethod = 1
            this.orderForm.payments = []
            this.orderForm.type = 0
            this.orderForm.orderId = null
            this.orderForm.items = []
            this.orderForm.tableId = null
            this.orderForm.description = null
            this.orderForm.useWallet = false
            this.orderForm.walletAmount = 0
            this.orderFormWalletAmount = 0
            this.orderForm.customerNumber = null
            this.orderForm.campaignId = null
            this.campaignDetails = null
            this.orderDetails.numberProducts = 0
            this.orderDetails.totalAmount = 0
            this.orderDetails.orderAmount = 0
            this.orderDetails.amountPayable = 0
            this.searchCustomer = null
            this.discountAmount = null
            this.ordersList = []
            this.customerPhoneNumber = null
            this.campaignsList = []
            this.isCustomerCampaign = false
            this.campaignsListMain.forEach(item => {
                if (item.type == 2) {
                    this.campaignsList.push(item)
                }
                if (item.type == 0 || item.type == 1) {
                    this.isCustomerCampaign = true
                }
            });
            if (this.campaignsList.length) {
                this.campaignDetails = this.campaignsList[0]
            }
            if (this.categories.length) {
                this.categories.forEach(obj => {
                    obj.products.forEach(product => {
                        product.number = 0;
                    });
                    if (obj.subCategories.length) {
                        obj.subCategories.forEach(subCategorie => {
                            subCategorie.products.forEach(productSub => {
                                productSub.number = 0;
                            });
                        });
                    }
                });
            }
            this.combinedPayment.forEach(item => {
                item.amount = null;
            });
        },
        orderUseWalletOk() {
            let amountPayable = Math.max(
                Math.round(this.calculatingTaxAuto
                    ? (this.orderDetails.amountPayable + (this.orderDetails.orderAmount * 0.10) -
                        (this.orderForm.useWallet ? this.orderForm.walletAmount : 0))
                    : (this.orderDetails.amountPayable - (this.orderForm.useWallet ?
                        this.orderForm.walletAmount : 0))),
                0
            )
            let orderFormWalletAmount = Number(this.orderFormWalletAmount);
            if (orderFormWalletAmount <= amountPayable && orderFormWalletAmount <= this.customer.loyaltyInfo.walletBalance && orderFormWalletAmount >= 0) {
                this.orderForm.useWallet = true
                this.orderForm.walletAmount = orderFormWalletAmount
            }
            else {
                this.$notif({ type: 'normal', title: 'مبلغ وارد شده صحیح نیست' });
            }
            this.orderFormWalletAmount = 0
        },
        createCustomer() {
            this.$refs.createCustomerValidation.validate().then((success) => {
                if (success) {
                    this.loading.createCustomer = true;
                    storeService.createCustomer(this.storeId, this.customerForm).then(({ data }) => {
                        this.customer = data
                        this.customerForm.gender = null
                        this.customerForm.birthDate = null
                        this.customerForm.lastName = null
                        this.customerForm.firstName = null
                        this.customerForm.phoneNumber = null
                        this.loading.createCustomer = false;
                        this.$refs.createCustomerValidation.reset();
                        this.$bvModal.hide('create-customer')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                    })
                        .catch(() => {
                            this.$bvModal.hide('create-customer')
                            this.customerForm.gender = null
                            this.customerForm.birthDate = null
                            this.customerForm.lastName = null
                            this.customerForm.firstName = null
                            this.customerForm.phoneNumber = null
                            this.loading.createCustomer = false;
                        });
                }
            });
        },
        getCustomerCampaign(customerId, dataCustomer, method, dataMethod) {
            this.campaignDetails = null
            this.campaignsList = []
            this.campaignsListMain.forEach(item => {
                if (item.type == 2) {
                    this.campaignsList.push(item)
                }
            });
            storeService.getCustomerCampaign(this.storeId, customerId).then(({ data }) => {
                let dataCampaignIds = data.campaignIds;
                dataCampaignIds.forEach(id => {
                    const found = this.campaignsListMain.find(c => c.id === id);
                    if (found) {
                        const alreadyExists = this.campaignsList.some(c => c.id === found.id);
                        if (!alreadyExists) {
                            this.campaignsList.unshift(found);
                        }
                    }
                });
                if (this.campaignsList.length) {
                    this.campaignDetails = this.campaignsList[0]
                }
                this.customer = dataCustomer
                this.customerPhoneNumber = null
                this.loading.customersFind = false
                this.$bvModal.hide('customers-find')
                if (method == "ordersPreorderFind") {
                    let ordersList = dataMethod.items
                    ordersList.forEach(product => {
                        this.orderDetails.numberProducts += product.count
                        this.orderDetails.orderAmount += (product.finalPrice * product.count)
                        this.orderDetails.totalAmount += (product.finalPrice * product.count)
                        this.orderDetails.amountPayable += (product.finalPrice * product.count)
                        let originalProduct = null;
                        for (let category of this.categories) {
                            originalProduct = category.products.find(p => p.id === product.productId);
                            if (originalProduct) break;
                            if (category.subCategories && category.subCategories.length) {
                                for (let subCategory of category.subCategories) {
                                    originalProduct = subCategory.products.find(p => p.id === product.productId);
                                    if (originalProduct) break;
                                }
                                if (originalProduct) break;
                            }
                        }
                        if (originalProduct) {
                            originalProduct.number = product.count;
                            this.ordersList.push(originalProduct);
                        }
                    });
                    this.orderForm.type = dataMethod.type
                    if (dataMethod.tableId) {
                        this.orderForm.tableId = dataMethod.tableId
                    }
                    if (dataMethod.description) {
                        this.orderForm.description = dataMethod.description
                    }
                    this.loadingPage = false;
                    if (dataMethod.customer) {
                        this.customer = {
                            firstName: dataMethod.customer.firstName,
                            id: dataMethod.customer.id,
                            lastName: dataMethod.customer.lastName,
                            phoneNumber: dataMethod.customer.phoneNumber,
                            number: dataMethod.customer.number,
                        }
                        if (dataMethod.customer.loyaltyInfo) {
                            this.customer.loyaltyInfo = {
                                loyaltyLevel: {
                                    number: dataMethod.customer.loyaltyInfo.loyaltyLevel ? dataMethod.customer.loyaltyInfo.loyaltyLevel.number : 0,
                                    name: dataMethod.customer.loyaltyInfo.loyaltyLevel ? dataMethod.customer.loyaltyInfo.loyaltyLevel.name : 0,
                                },
                                score: dataMethod.customer.loyaltyInfo.score,
                                walletBalance: dataMethod.customer.loyaltyInfo.walletBalance,
                            }
                        }
                    }
                    this.$bvModal.hide('pre-invoices-list')
                    this.loading.ordersToday = false
                    if (!this.$route.query.id) {
                        this.$notif({ type: 'success', title: 'پیش سفارش با موفقیت به سفارش اضافه شد' });
                    }
                }
                else {
                    this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                }
            })
                .catch(() => {
                    this.loading.customersFind = false
                })
        },
        customersFind() {
            this.$refs.customersFindValidation.validate().then((success) => {
                if (success) {
                    this.orderForm.useWallet = false
                    this.orderForm.walletAmount = 0
                    this.orderFormWalletAmount = 0
                    if (this.searchCustomer) {
                        this.loading.customersFind = true;
                        this.customer = {
                            firstName: this.searchCustomer.firstName,
                            id: this.searchCustomer.id,
                            lastName: this.searchCustomer.lastName,
                            phoneNumber: this.searchCustomer.phoneNumber,
                            number: this.searchCustomer.number,
                        }
                        if (this.searchCustomer.loyaltyLevel) {
                            this.customer.loyaltyInfo = {
                                loyaltyLevel: {
                                    number: this.searchCustomer.loyaltyLevel ? this.searchCustomer.loyaltyLevel.number : 0,
                                    name: this.searchCustomer.loyaltyLevel ? this.searchCustomer.loyaltyLevel.name : 0,
                                },
                                score: this.searchCustomer.score,
                                walletBalance: this.searchCustomer.walletBalance,
                            }
                        }
                        if (this.isCustomerCampaign) {
                            this.getCustomerCampaign(this.customer.id, this.customer)
                        }
                        else {
                            this.$bvModal.hide('customers-find')
                            this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                            this.loading.customersFind = false;
                        }
                        this.searchCustomer = null
                        this.customerPhoneNumber = null
                        this.$refs.customersFindValidation.reset();
                    }
                    else {
                        this.customerForm.gender = null
                        this.customerForm.birthDate = null
                        this.customerForm.lastName = null
                        this.customerForm.firstName = null
                        this.customerForm.phoneNumber = null
                        this.loading.customersFind = true;
                        storeService.customersFind(this.storeId, this.customerPhoneNumber).then(({ data }) => {
                            if (data.isExists) {
                                if (this.isCustomerCampaign) {
                                    this.getCustomerCampaign(data.customer.id, data.customer)
                                }
                                else {
                                    this.customer = data.customer
                                    this.customerPhoneNumber = null
                                    this.loading.customersFind = false
                                    this.$bvModal.hide('customers-find')
                                    this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                                }
                            }
                            else {
                                this.customerForm.phoneNumber = this.customerPhoneNumber
                                if (this.customerFirstName) {
                                    this.customerForm.firstName = this.customerFirstName
                                }
                                if (this.customerLastName) {
                                    this.customerForm.lastName = this.customerLastName
                                }
                                this.$bvModal.hide('customers-find')
                                this.$bvModal.show('create-customer')
                                this.customerPhoneNumber = null
                                this.$notif({ type: 'normal', title: 'مشتری با این شماره یافت نشد' });
                                this.loading.customersFind = false
                            }
                            this.$refs.customersFindValidation.reset();
                        })
                            .catch(() => {
                                this.$refs.customersFindValidation.reset();
                                this.loading.customersFind = false
                            });
                    }
                }
            });
        },
        applyDiscount(type) {
            if (type == 'rial') {
                let discountAmountNumber = Number(this.discountAmount);
                let discountAmount = Math.round(discountAmountNumber);
                let totalAmount = this.calculatingTaxAuto ? (this.orderDetails.totalAmount + (this.orderDetails.orderAmount * 0.10)) : this.orderDetails.totalAmount
                if (discountAmount > totalAmount) {
                    this.$notif({ type: 'normal', title: 'تخفیف بیشتر از مبلغ قابل پرداخت است' });
                }
                else {
                    this.orderForm.discountAmount = discountAmount;
                    this.orderDetails.amountPayable = this.orderDetails.totalAmount - this.orderForm.discountAmount
                }
                this.percentageDiscountAmount = null
                this.discountAmount = null
            }
            if (type == 'percentage') {
                let percentageDiscountAmount = Number(this.percentageDiscountAmount);
                let totalAmount = this.calculatingTaxAuto ? (this.orderDetails.totalAmount + (this.orderDetails.orderAmount * 0.10)) : this.orderDetails.totalAmount;
                let discountAmount = Math.round((percentageDiscountAmount / 100) * totalAmount)
                if (discountAmount > totalAmount) {
                    this.$notif({ type: 'normal', title: 'تخفیف بیشتر از مبلغ قابل پرداخت است' });
                }
                else {
                    this.orderForm.discountAmount = discountAmount;
                    this.orderDetails.amountPayable = this.orderDetails.totalAmount - this.orderForm.discountAmount
                }
                this.percentageDiscountAmount = null
                this.discountAmount = null
            }
        },
        addedToOrderList(product) {
            if (product.isAvailable) {
                let productExists = this.ordersList.some(orderProduct => orderProduct.id === product.id);
                if (!productExists) {
                    this.ordersList.push(product);
                    product.number = 1
                    this.orderDetails.numberProducts += 1
                    this.orderDetails.orderAmount += product.finalPrice
                    this.orderDetails.totalAmount += product.finalPrice
                    this.orderDetails.amountPayable += product.finalPrice
                }
                else {
                    product.number += 1
                    this.orderDetails.numberProducts += 1
                    this.orderDetails.orderAmount += product.finalPrice
                    this.orderDetails.totalAmount += product.finalPrice
                    this.orderDetails.amountPayable += product.finalPrice
                }
            }
            else {
                this.$notif({ type: 'warning', title: `"${product.name_Fa}" ناموجود است` });
            }
        },
        addProduct(product) {
            product.number += 1
            this.orderDetails.numberProducts += 1
            this.orderDetails.orderAmount += product.finalPrice
            this.orderDetails.totalAmount += product.finalPrice
            this.orderDetails.amountPayable += product.finalPrice
        },
        subtractProduct(product) {
            product.number -= 1
            this.orderDetails.numberProducts -= 1
            this.orderDetails.totalAmount -= product.finalPrice
            this.orderDetails.orderAmount -= product.finalPrice
            this.orderDetails.amountPayable -= product.finalPrice
            if (product.number == 0) {
                this.ordersList = this.ordersList.filter((item) => item.id !== product.id);
            }
        },
        selectCategory(category) {
            this.category = category
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                this.categories = data.categories
                if (this.categories.length) {
                    this.categories.forEach(obj => {
                        obj.products.forEach(product => {
                            product.number = 0;
                        });
                        if (obj.subCategories.length) {
                            obj.subCategories.forEach(subCategorie => {
                                subCategorie.products.forEach(productSub => {
                                    productSub.number = 0;
                                });
                            });
                        }
                    });
                }
                if (this.accessHandling('subscription', 3)) {
                    this.getCampaignsActives()
                }
                else {
                    this.getInfo()

                }
            })
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getAllProducts();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        registerOrder(order) {
            let newOrder = order
            newOrder.id = this.orderNumber
            this.printQueue.push(newOrder);
            this.orderNumber++;
            if (!this.isPrinting) {
                this.startPrinting();
            }
        },
        startPrinting() {
            this.isPrinting = true;
            const printNext = () => {
                if (this.printQueue.length === 0) {
                    this.isPrinting = false;
                    return;
                }
                this.orderPrint.items = this.ordersList
                this.orderPrint.createdAt = this.dataResponse.createdAt
                this.orderPrint.dailyOrderNumber = this.dataResponse.dailyOrderNumber
                this.orderPrint.storeOrderNumber = this.dataResponse.storeOrderNumber
                this.orderPrint.urlName = this.urlName
                this.orderPrint.orderAmount = this.dataResponse.totalAmount
                this.orderPrint.amountPayable = this.dataResponse.payableAmount
                this.orderPrint.taxAmount = this.dataResponse.taxAmount
                this.orderPrint.discountAmount = this.dataResponse.discountAmount
                this.orderPrint.usedWalletAmount = this.dataResponse.usedWalletAmount
                this.orderPrint.campaignDiscountAmount = this.dataResponse.campaignDiscountAmount
                this.orderPrint.productDiscountAmount = this.dataResponse.productDiscountAmount
                this.orderPrint.firstName = this.customer.firstName
                this.orderPrint.lastName = this.customer.lastName
                if (this.orderForm.type == 1) {
                    this.orderPrint.phoneNumber = this.customer.phoneNumber
                    this.orderPrint.address = this.customer.address
                }
                setTimeout(() => {
                    this.$refs.Printer.printCustomerInvoice();
                }, 100);
                if (this.$route.query.id) {
                    setTimeout(() => {
                        this.$router.push('/daily-orders')
                    }, 1000);
                }
                this.removeFromQueueById(this.printQueue[0].id);
                setTimeout(printNext, 1000);
            };
            printNext();
        },
        removeFromQueueById(orderId) {
            this.printQueue = this.printQueue.filter(order => order.id !== orderId);
        },
        ordersCreateHandle() {
            if (this.ordersList.length) {
                this.orderForm.payments = []
                if (this.paymentMethod == 4) {
                    this.$bvModal.show('enter-amount')
                }
                else {
                    this.orderForm.payments = [{
                        method: this.paymentMethod,
                        amount: Math.max(
                            Math.round(this.calculatingTaxAuto
                                ? (this.orderDetails.amountPayable + (this.orderDetails.orderAmount * 0.10) -
                                    (this.orderForm.useWallet ? this.orderForm.walletAmount : 0))
                                : (this.orderDetails.amountPayable - (this.orderForm.useWallet ?
                                    this.orderForm.walletAmount : 0))),
                            0
                        )
                    }]
                    this.ordersCreate()
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'برای ثبت سفارش حداقل یک مورد اضافه کنید' });
            }
        },
        combinedPaymentHandle() {
            this.orderForm.payments = []
            let amountPayable = Math.max(
                Math.round(((this.calculatingTaxAuto ? this.orderDetails.amountPayable +
                    (this.orderDetails.orderAmount * 0.10) :
                    this.orderDetails.amountPayable) - (this.campaignDetails ? ((this.calculatingTaxAuto ?
                        (this.orderDetails.totalAmount +
                            (this.orderDetails.orderAmount * 0.10)) : this.orderDetails.totalAmount) *
                        (this.campaignDetails.discountPercent / 100)) :
                        0) - (this.orderForm.useWallet ? this.orderForm.walletAmount :
                            0))), 0)
            let totalAmountPaid = 0
            let tempAmount = 0
            this.combinedPayment.forEach(item => {
                if (item.amount) {
                    tempAmount = Number(item.amount);
                    tempAmount = Math.round(tempAmount);
                    totalAmountPaid += tempAmount;
                    this.orderForm.payments.push({
                        method: item.method,
                        amount: tempAmount
                    })
                }
            });
            if (totalAmountPaid == amountPayable) {
                this.ordersCreate()
            }
            else {
                this.$notif({ type: 'normal', title: 'مبالغ وارد شده با مبلغ قابل پرداخت مغایرت دارد' });
            }

        },
        ordersCreate() {
            this.loading.ordersCreate = true;
            this.orderForm.items = []
            this.ordersList.forEach(product => {
                this.orderForm.items.push({
                    productId: product.id,
                    count: product.number
                });
            });
            if (this.campaignDetails) {
                this.orderForm.campaignId = this.campaignDetails.id
            }
            this.orderForm.customerNumber = this.customer.number
            if (this.orderForm.walletAmount == 0) {
                this.orderForm.walletAmount = null
            }
            storeService.ordersCreate(this.storeId, this.orderForm).then(({ data }) => {
                this.dataResponse = data
                this.loading.ordersCreate = false;
                this.$bvModal.hide('enter-amount')
                this.$notif({ type: 'success', title: 'سفارش با موفقیت ثبت شد' });
                if (this.automaticPrinting) {
                    if (this.certificateId || this.certificateId == 0) {
                        this.registerOrder(this.orderForm);
                    }
                    else {
                        this.deleteInvoice()
                        if (this.$route.query.id) {
                            this.$router.push('/daily-orders')
                        }
                    }
                }
                else {
                    this.deleteInvoice()
                    if (this.$route.query.id) {
                        this.$router.push('/daily-orders')
                    }
                }
            })
                .catch(() => {
                    this.loading.ordersCreate = false;
                });
        },
        ordersToday() {
            if (!this.loading.ordersToday) {
                this.loading.ordersToday = true
                this.searchPreInvoices = null
                this.preInvoicesList = []
                storeService.ordersToday(this.storeId, this.ordersTodayParameters).then(({ data }) => {
                    this.preInvoicesList = data.items
                    this.filterPreInvoicesList = this.preInvoicesList
                    this.loading.ordersToday = false
                    this.$bvModal.show('pre-invoices-list')
                })

                    .catch(() => {
                        this.loading.ordersToday = false
                    });
            }
        },
        ordersPreorderFind(item) {
            if (!this.loading.ordersToday) {
                this.loading.ordersToday = true
                this.deleteInvoice()
                this.orderForm.orderId = item.id
                storeService.ordersPreorderFind(this.storeId, item.dailyNumber).then(({ data }) => {
                    if (this.isCustomerCampaign && data.customer) {
                        this.getCustomerCampaign(data.customer.id, data.customer, "ordersPreorderFind", data)
                    }
                    else {
                        let ordersList = data.items
                        ordersList.forEach(product => {
                            this.orderDetails.numberProducts += product.count
                            this.orderDetails.orderAmount += (product.finalPrice * product.count)
                            this.orderDetails.totalAmount += (product.finalPrice * product.count)
                            this.orderDetails.amountPayable += (product.finalPrice * product.count)
                            let originalProduct = null;
                            for (let category of this.categories) {
                                originalProduct = category.products.find(p => p.id === product.productId);
                                if (originalProduct) break;
                                if (category.subCategories && category.subCategories.length) {
                                    for (let subCategory of category.subCategories) {
                                        originalProduct = subCategory.products.find(p => p.id === product.productId);
                                        if (originalProduct) break;
                                    }
                                    if (originalProduct) break;
                                }
                            }
                            if (originalProduct) {
                                originalProduct.number = product.count;
                                this.ordersList.push(originalProduct);
                            }
                        });
                        this.orderForm.type = data.type
                        if (data.tableId) {
                            this.orderForm.tableId = data.tableId
                        }
                        if (data.description) {
                            this.orderForm.description = data.description
                        }
                        this.loadingPage = false;
                        if (data.customer) {
                            this.customer = {
                                firstName: data.customer.firstName,
                                id: data.customer.id,
                                lastName: data.customer.lastName,
                                phoneNumber: data.customer.phoneNumber,
                                number: data.customer.number,
                            }
                            if (data.customer.loyaltyInfo) {
                                this.customer.loyaltyInfo = {
                                    loyaltyLevel: {
                                        number: data.customer.loyaltyInfo.loyaltyLevel ? data.customer.loyaltyInfo.loyaltyLevel.number : 0,
                                        name: data.customer.loyaltyInfo.loyaltyLevel ? data.customer.loyaltyInfo.loyaltyLevel.name : 0,
                                    },
                                    score: data.customer.loyaltyInfo.score,
                                    walletBalance: data.customer.loyaltyInfo.walletBalance,
                                }
                            }
                        }
                        this.$bvModal.hide('pre-invoices-list')
                        this.loading.ordersToday = false
                        this.loading.customersFind = false;
                        if (!this.$route.query.id) {
                            this.$notif({ type: 'success', title: 'پیش سفارش با موفقیت به سفارش اضافه شد' });
                        }
                    }
                })
                    .catch(() => {
                        this.$bvModal.hide('pre-invoices-list')
                        this.loading.ordersToday = false
                        this.loadingPage = false;
                    });
            }
        },
        getInfo() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                this.calculatingTaxAuto = data.calculatingTaxAuto
                data.name_Fa ? this.provider.name = data.name_Fa : this.provider.name = data.name_En;
                this.urlName = data.name_En
                this.provider.logo = data.logoImage;
                if (this.$route.query.id) {
                    let item = {}
                    item.id = this.$route.query.id
                    item.dailyNumber = this.$route.query.dailyNumber
                    this.ordersPreorderFind(item)
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.certificateId = localStorage.getItem("certificateId");
        window.addEventListener('keydown', this.keyboardHandling);
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.storeId = localStorage.getItem("storeId");
        let automaticPrinting = localStorage.getItem("automaticPrinting")
        if (this.certificateId || this.certificateId == 0) {
            this.automaticPrinting = true
        }
        else {
            this.automaticPrinting = false
        }
        if (automaticPrinting != null) {
            automaticPrinting == 'true' ? this.automaticPrinting = true : this.automaticPrinting = false
        }
        this.getCompletionStatus();
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.keyboardHandling);
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.invoice-registration-cover {
    background-color: rgb(0 0 0 / 80%);
    bottom: 0;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
}

.invoice-registration-cover-product {
    bottom: 0;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
}

.pre-invoices-item {
    &:hover {
        background-color: #55618930;
    }
}

.invoice-registration-bg {
    @media (max-width: 767px) {
        width: 100px;
        height: 100px;
    }

    @media (min-width: 767px) {
        width: 150px;
        height: 110px;
    }

    background-color: #000000;
}

.invoice-registration-bg-main {
    @media (max-width: 767px) {
        width: 100px;
        height: 100px;
    }

    @media (min-width: 767px) {
        width: 150px;
        height: 110px;
    }
}

.orders-container {
    height: 286.8px;
    overflow-y: scroll;
}

.orders-container::-webkit-scrollbar {
    width: 4px;
    border-radius: 6px;
}

.orders-container::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.orders-container::-webkit-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.orders-container::-webkit-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.overflow-y-scroll-invoice {
    @media (min-width: 767px) {
        height: 743px;
        overflow-y: scroll;
    }
}

.overflow-y-scroll-invoice::-webkit-scrollbar {
    width: 4px;
    border-radius: 6px;
}

.overflow-y-scroll-invoice::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.overflow-y-scroll-invoice::-webkit-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.overflow-y-scroll-invoice::-webkit-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.scrollbar-bills::-moz-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.scrollbar-bills::-moz-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.scrollbar-bills::-moz-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.display-none-sm-invoice {
    @media (max-width: 767px) {
        display: none;
    }

    @media (min-width: 767px) {
        display: flex;
        align-items: center;
    }
}

.border-bottom-invoice {
    border-bottom: 1px #93939336 solid;
}

.bg-info-invoice {
    background-color: #576fbd;
    transition: background-color 0.1s ease-in-out;
}

.line-between-two-elements-invoice {
    flex-grow: 1;
    border-bottom: 1px dashed #9393935d;
}

.toggle-content-invoice {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.text-ellipsis-single-invoice {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>